import * as React from 'react';
import { Link } from 'react-router-dom';
import { Order } from '../order';
import * as dateFormat from 'dateformat';

export interface Props {
  order: Order;
  index: number;
}

const DATE_FORMAT = 'd mmmm, yyyy - HH:MM:s';

const indicatorClasses = (status: string) => {
  return `db w1 h1 br-100 bg-${statusToColor(status)}`;
};

const statusToColor = (status: string) => {
  switch (status) {
    case 'paid':
      return 'gold';
    case 'shipped':
    case 'delivered':
      return 'green';
    case 'unpaid':
    case 'refunded':
    case 'partially_refunded':
    case 'cancelled':
      return 'red';
  }
};

const getFulfillmentLabel = (order: Order) => {
  if (order.status === 'cancelled') {
    return 'Cancelled';
  }

  return order.shipments[0].fulfillment ? 'Fulfilled' : 'Unfullfilled';
};

export default function OrderListItem(props: Props) {
  return (
    <div
      className={`flex justify-stretch items-center pv2 pv3-ns ${
        props.index > 0 ? 'bt b--black-10' : ''
      }`}
    >
      <div className="mr4">
        <div className={indicatorClasses(props.order.status)} />
      </div>
      <div className="flex-auto w-20">
        <h4 className="lh-copy ma0 mb2 f7 black-50 ttu">
          {dateFormat(props.order.created_at, DATE_FORMAT)}
        </h4>
        <p className="lh-title ma0 black truncate ttu f6 b">
          #{props.order.order_number}
        </p>
      </div>
      <div className="flex-auto w-40">
        <h4 className="lh-copy ma0 mb2 f7 black-50 ttu">Shipping To</h4>
        <p className="lh-title ma0 black truncate">
          {props.order.shipping_address.first_name}{' '}
          {props.order.shipping_address.last_name},{' '}
          {props.order.shipping_address.city},{' '}
          {props.order.shipping_address.country},{' '}
          {props.order.shipping_address.postal_code}
        </p>
      </div>
      <div className="flex-auto w-20">
        <h4 className="lh-copy ma0 mb2 f7 black-50 ttu">Fulfillment</h4>
        <p
          className={`lh-title ma0 truncate b f6 ttu ${
            props.order.shipments[0].fulfillment ? 'green' : 'blue'
          }`}
        >
          {getFulfillmentLabel(props.order)}
        </p>
      </div>
      <div className="flex-auto w-20">
        <h4 className="lh-copy ma0 mb2 f7 black-50 ttu">Status</h4>
        <p
          className={`lh-title ma0 truncate b f6 ttu ${statusToColor(
            props.order.status,
          )}`}
        >
          {props.order.status}
        </p>
      </div>
      <div className="tc ml4">
        <Link
          to={{
            pathname: `/orders/${props.order.id}`,
            state: {
              order: props.order,
            },
          }}
          className="link black underline b dim"
        >
          View
        </Link>
      </div>
    </div>
  );
}
